export const aciByCar = {
    iconName: 'by-car',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    d: 'M16.44 17.11H7.55M16.637 17.333a1.333 1.333 0 102.666 0 1.333 1.333 0 00-2.666 0zM4.637 17.333a1.333 1.333 0 102.666 0 1.333 1.333 0 00-2.666 0z',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
            {
                attr: {
                    d: 'M19.304 17.333h1.362A1.334 1.334 0 0021.999 16a4.024 4.024 0 00-4.028-4s-2-6-7.333-6c-4 0-8.296 2.384-8.637 9.97a1.307 1.307 0 001.304 1.363h1.333M17.97 12H2.653M10 12V6.021',
                    stroke: 'currentColor',
                    'stroke-width': '1.2',
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                },
            },
        ],
    },
};
